const a=s=>{const{_ref:t}=s,[,e,i,n]=t.split("-"),[r,o]=i.split("x");return{ref:t,assetId:e,format:n,dimensions:i,intrinsicHeight:o,intrinsicWidth:r}};export{a as getSonosImageDetails};
